import React, { Component } from 'react';
import Dashboard from './Dashboard';
import { getInstrumentsList } from './Dashboard.actions';

class DashboardContainer extends Component {
  constructor() {
    super();

    this.state = {
      display: {},
      data: [],
    };
  }

  componentDidMount() {
    getInstrumentsList().then((res) => {
      let r = res.body;
      if (!r.Data || !r.Display) {
        return;
      }

      this.setState({ data: r.Data.slice(0), display: r.Display.slice(0) });
    });
  }

  render() {
    return <Dashboard data={this.state.data} display={this.state.display} />;
  }
}

export default DashboardContainer;
